import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { filter, switchMap } from 'rxjs';
import { ZohoBooksFeatureService } from '../../../features/zoho-books-feature/zoho-books-feature.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { DatePipe, DecimalPipe } from '@angular/common';
import { HighlightPipe } from '../../../utils/highlight.pipe';
import { ZohoBooksFiltersComponent } from './components/zoho-books-filters/zoho-books-filters.component';

@Component({
  selector: 'app-zoho-books',
  standalone: true,
  imports: [MatExpansionModule, MatProgressSpinnerModule, MatButton, DecimalPipe, DatePipe, HighlightPipe, ZohoBooksFiltersComponent],
  templateUrl: './zoho-books.component.html',
  styleUrl: './zoho-books.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZohoBooksComponent implements OnInit {
  _zohoBooksFeature = inject(ZohoBooksFeatureService);

  isExpanded = signal(false);

  ngOnInit() {
    this._zohoBooksFeature.checkAuthStatus()?.pipe(
      filter((result) => result.connected),
      switchMap(() => this._zohoBooksFeature.fetchTimeEntries()),
    ).subscribe({ next: () => this.isExpanded.set(true) });
  }

  connectZoho() {
    this._zohoBooksFeature.connectZoho();
  }

  onDateFilterChanged() {
    this._zohoBooksFeature.fetchTimeEntries().subscribe({
      next: () => this.isExpanded.set(true),
    });
  }

  groupByDate() {
    return this._zohoBooksFeature.groupByDate(this._zohoBooksFeature.timeEntries());
  }

  groupByWeek() {
    return this._zohoBooksFeature.groupByWeek(this._zohoBooksFeature.timeEntries());
  }

  groupByMonth() {
    return this._zohoBooksFeature.groupByMonth(this._zohoBooksFeature.timeEntries());
  }

  toDecimalHours(logTime: string): number {
    const [h, m] = logTime.split(':').map(Number);
    return h + m / 60;
  }
}
